module.exports = __webpack_public_path__ + "img/lesson_fifty.ae725370.png";